var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.63438 0 0.5 3.13438 0.5 7C0.5 10.8656 3.63438 14 7.5 14C11.3656 14 14.5 10.8656 14.5 7C14.5 3.13438 11.3656 0 7.5 0ZM10.0844 9.65938L9.05313 9.65469L7.5 7.80313L5.94844 9.65312L4.91563 9.65781C4.84688 9.65781 4.79063 9.60312 4.79063 9.53281C4.79063 9.50312 4.80156 9.475 4.82031 9.45156L6.85313 7.02969L4.82031 4.60938C4.80143 4.58647 4.79096 4.5578 4.79063 4.52812C4.79063 4.45937 4.84688 4.40312 4.91563 4.40312L5.94844 4.40781L7.5 6.25938L9.05156 4.40938L10.0828 4.40469C10.1516 4.40469 10.2078 4.45937 10.2078 4.52969C10.2078 4.55937 10.1969 4.5875 10.1781 4.61094L8.14844 7.03125L10.1797 9.45312C10.1984 9.47656 10.2094 9.50469 10.2094 9.53438C10.2094 9.60313 10.1531 9.65938 10.0844 9.65938Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectIcon);
export default __webpack_public_path__ + "static/media/incorrectIcon.3c0959361f9d5e172e8780c73d4fc3ff.svg";
export { ForwardRef as ReactComponent };